import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { createMaster, masterData } from "../../../configs/WebService";
import { setFormData } from "../../../features/QuestionPaper/createpaper/redux/slice";
import { BASE_URL } from "../../../configs/WebServiceUrl";
import { apiKeyHeader } from "../../../configs/ApiKeys";

export const submitMasterData = createAsyncThunk(
  "masterData/submitMasterData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(createMaster, payload, {
       
          headers: apiKeyHeader(),
        
      });
      return response.data;
    } catch (error) {
      console.error("Error submitting master data:", error);
      return rejectWithValue(error.response?.data || "Server Error");
    }
  }
);
export const getMasterDataByUserId = createAsyncThunk(
  "masterData/getMasterDataByUserId",
  async (user_id, { rejectWithValue, dispatch }) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userRole = userData?.roles;
    const isUserRole = userRole?.toLowerCase() === "user";

    try {
      const id = isUserRole ? 1 : user_id;

      const response = await axios.get(
        `${masterData}/${id}`,
        {
          headers: apiKeyHeader(),
        }
      );

      dispatch(
        setFormData({
          name: "schoolName",
          value: response?.data?.school_name || "",
        })
      );

      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return null;
      }

      console.error("Error fetching master data:", error);
      return rejectWithValue(error.response?.data || "Server Error");
    }
  }
);
      
 
export const updateMasterData = createAsyncThunk(
  "masterData/updateMasterData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        // "http://localhost:5010/masterdata/master-data",
        masterData,
        payload,
        {
          headers: apiKeyHeader(),
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating master data:", error);
      return rejectWithValue(error.response?.data || "Server Error");
    }
  }
);

export const getProposedClassList = createAsyncThunk(
  'classes/getProposedClassList', // optional action type
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/timetable/classes/proposedclasses`,
        {
          headers: apiKeyHeader(),
        }
      );
      return response.data.classes;
    } catch (error) {
      console.error("Error fetching proposed classes:", error);
      return rejectWithValue(error.response?.data || "Server Error");
    }
  }
);
